import React, { useState, useEffect } from 'react';
import Ratio from 'react-ratio';
import { MainContent, MainFooter, MainHeader } from './index';
import images from '../assets';
import { AlermPopArea, VerticalSp } from '../components/Common';
import { CheckBox, CheckMark } from '../components/auth/login';
import apiClient from '../_utils/axios';
import Store from 'store';
import moment from 'moment';
import { useTranslation } from 'react-i18next';
import { useDispatch } from 'react-redux';

const MainLayout = ({ location }) => {
  const [popupListKo, setPopupListKo] = useState([]);
  const [popupListEn, setPopupListEn] = useState([]);
  const { t } = useTranslation();
  const { pathname } = location;
  const dispatch = useDispatch();

  useEffect(() => {
    const getPopupList = async () => {
      const resKo = await apiClient.get('/web/popup?lang=KO');
      const resEn = await apiClient.get('/web/popup?lang=EN');

      resKo.data.forEach(item => {
        item.is_show = Store.get(`popup-${item.id}`) !== moment().format('YYYY-MM-DD');
        item.is_oneday = false;
      });

      resEn.data.forEach(item => {
        item.is_show = Store.get(`popup-${item.id}`) !== moment().format('YYYY-MM-DD');
        item.is_oneday = false;
      });

      setPopupListKo(resKo.data);
      setPopupListEn(resEn.data);
    };

    //장바구니에 담긴 상품의 개수
    const onCartCount = async () =>{
      if (Store.get('accessToken') !== undefined) {
        const res = await apiClient.get('/web/cart/count');
        if(res){
          dispatch({
            type : 'set',
            payload : {
              totalCartCount: res.data.totalCount,
            }
          })
        }
      }
    }

    getPopupList();
    onCartCount();
  }, []);

  const closeAlermPop = (index, id, lang) => {
    if (lang === 'KO') {
      const updatedPopupListKo = [...popupListKo];
      updatedPopupListKo[index].is_show = false;
      setPopupListKo(updatedPopupListKo);

      if (updatedPopupListKo[index].is_oneday) {
        Store.set(`popup-${id}`, moment().format('YYYY-MM-DD'));
      } else {
        Store.remove(`popup-${id}`);
      }
    } else {
      const updatedPopupListEn = [...popupListEn];
      updatedPopupListEn[index].is_show = false;
      setPopupListEn(updatedPopupListEn);

      if (updatedPopupListEn[index].is_oneday) {
        Store.set(`popup-${id}`, moment().format('YYYY-MM-DD'));
      } else {
        Store.remove(`popup-${id}`);
      }
    }
  };

  const setOneday = (index, lang) => {
    if (lang === 'KO') {
      const updatedPopupListKo = [...popupListKo];
      updatedPopupListKo[index].is_oneday = !updatedPopupListKo[index].is_oneday;
      setPopupListKo(updatedPopupListKo);
    } else {
      const updatedPopupListEn = [...popupListEn];
      updatedPopupListEn[index].is_oneday = !updatedPopupListEn[index].is_oneday;
      setPopupListEn(updatedPopupListEn);
    }
  };

    

  return (
    <div style={{ width: '100%' }}>
      {pathname !== '/selfauth' && <MainHeader />}
      <MainContent />
      {pathname !== '/selfauth' && <MainFooter />}
      {pathname !== '/selfauth' &&
        Store.get('lang') === 'kr' &&
        popupListKo.map(
          (item, index) =>
            item.is_show &&
            Store.get(`popup-${item.id}`) !== moment().format('YYYY-MM-DD') && (
              <AlermPopArea key={`popup-${index}`}>
                <div
                  style={{ fontFamily: 'NanumSqEB', fontSize: 24, color: '#ff8a06', lineHeight: '25px', height: 24 }}
                >
                  TEXTILE DESIGN BANK
                </div>
                <VerticalSp sp={11} />
                {/* <Ratio
                  ratio={1}
                  style={{
                    backgroundColor: '#eeeeee',
                    width: '100%',
                    backgroundImage: `url(${process.env.REACT_APP_S3_BUCKET_DOMAIN}${item.popup_img})`,
                    backgroundSize: 'cover',
                    cursor: 'pointer',
                  }}
                  onClick={() => window.open(`http://${item.popup_url}`)}
                /> */}
                <img
                    src={`${process.env.REACT_APP_S3_BUCKET_DOMAIN}${item.popup_img}`}
                    alt="Popup"
                    style={{
                      width: '100%',
                      height: 'auto', // 높이를 자동으로 설정
                      objectFit: 'contain', // 이미지 크기가 부모에 맞게 조절되도록 함
                      cursor: 'pointer',
                      zIndex: '999'
                  }}
                  onClick={() => {
                    setOneday(index, item.popup_lang)
                    closeAlermPop(index, item.id, item.popup_lang)
                    window.open(`http://${item.popup_url}`)
                    }
                  }
                />
                <VerticalSp sp={11} />
                <div
                  style={{ width: '100%', display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}
                >
                  <div
                    style={{
                      display: 'flex',
                      alignItems: 'center',
                      cursor: 'pointer',
                      fontFamily: 'NSCJKrR',
                      fontSize: 14,
                      color: 'black',
                    }}
                  >
                    <CheckBox onClick={() => setOneday(index, item.popup_lang)}>
                      <CheckMark checked={item.is_oneday} />
                      {t('do_not_open_for_a_day')}
                    </CheckBox>
                  </div>
                  <div
                    onClick={() => closeAlermPop(index, item.id, item.popup_lang)}
                    style={{
                      display: 'flex',
                      alignItems: 'center',
                      cursor: 'pointer',
                      fontFamily: 'NSCJKrR',
                      fontSize: 14,
                      color: 'black',
                    }}
                  >
                    <img alt="" src={images.icon_close} style={{ marginRight: 10 }} />
                    {t('close')}
                  </div>
                </div>
              </AlermPopArea>
            ),
        )}
      {pathname !== '/selfauth' &&
        Store.get('lang') !== 'kr' &&
        popupListEn.map(
          (item, index) =>
            item.is_show &&
            Store.get(`popup-${item.id}`) !== moment().format('YYYY-MM-DD') && (
              <AlermPopArea key={`popup-${index}`}>
                <div
                  style={{ fontFamily: 'NanumSqEB', fontSize: 24, color: '#ff8a06', lineHeight: '25px', height: 24 }}
                >
                  TEXTILE DESIGN BANK
                </div>
                <VerticalSp sp={11} />
                {/* <Ratio
                  ratio={1}
                  style={{
                    backgroundColor: '#eeeeee',
                    width: '100%',
                    backgroundImage: `url(${process.env.REACT_APP_S3_BUCKET_DOMAIN}${item.popup_img})`,
                    backgroundSize: 'cover',
                    cursor: 'pointer',
                  }}
                  onClick={() => window.open(`http://${item.popup_url}`)}
                /> */}
                  <img
                    src={`${process.env.REACT_APP_S3_BUCKET_DOMAIN}${item.popup_img}`}
                    alt="Popup"
                    style={{
                      width: '100%',
                      height: 'auto', // 높이를 자동으로 설정
                      objectFit: 'contain', // 이미지 크기가 부모에 맞게 조절되도록 함
                      cursor: 'pointer',
                      zIndex: '999'
                  }}
                  onClick={() => {
                    setOneday(index, item.popup_lang)
                    closeAlermPop(index, item.id, item.popup_lang)
                    window.open(`http://${item.popup_url}`)
                    }
                  }
                />
                <VerticalSp sp={11} />
                <div
                  style={{ width: '100%', display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}
                >
                  <div
                    style={{
                      display: 'flex',
                      alignItems: 'center',
                      cursor: 'pointer',
                      fontFamily: 'NSCJKrR',
                      fontSize: 14,
                      color: 'black',
                    }}
                  >
                    <CheckBox onClick={() => setOneday(index, item.popup_lang)}>
                      <CheckMark checked={item.is_oneday} />
                      {t('do_not_open_for_a_day')}
                    </CheckBox>
                  </div>
                  <div
                    onClick={() => closeAlermPop(index, item.id, item.popup_lang)}
                    style={{
                      display: 'flex',
                      alignItems: 'center',
                      cursor: 'pointer',
                      fontFamily: 'NSCJKrR',
                      fontSize: 14,
                      color: 'black',
                    }}
                  >
                    <img alt="" src={images.icon_close} style={{ marginRight: 10 }} />
                    {t('close')}
                  </div>
                </div>
              </AlermPopArea>
            ),
        )}
    </div>
  );
};

export default MainLayout;
